"use client";

import { useEffect, useState } from "react";
import { getConversations } from "@/lib/api";
import { getMe } from "@/lib/auth-store";

/**
 * Total unread messages across conversations, for the Matches tab badge.
 * Resolves to 0 for signed-out visitors. Best-effort — a failure just yields 0.
 */
export function useUnreadCount(): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!getMe()) return;
    let alive = true;
    getConversations()
      .then((res) => {
        if (!alive) return;
        setCount(res.items.reduce((sum, c) => sum + c.unreadCount, 0));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return count;
}
